import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const Title = () => <span>
    <img className="region-title-map" src={`../images/map-prairies-lakes.png`} />
    Prairies and Lakes
  </span>;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AdGroup = makeShortcode("AdGroup");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const StatePark = makeShortcode("StatePark");
const RegionListing = makeShortcode("RegionListing");
const layoutProps = {
  Title,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`From fast-moving rides to slow-moving experiences, the heartland of Texas offers something for everyone`}</p>
    </PageDescription>
    <AdGroup id={['ad26', 'ad27', 'ad31']} mdxType="AdGroup" />
    <Row mdxType="Row">
      <Column colSm={12} colMd={6} colLg={10} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAUarWa55YH//xAAZEAACAwEAAAAAAAAAAAAAAAAAAQIREgP/2gAIAQEAAQUCj0R0elGknWsopH//xAAXEQEAAwAAAAAAAAAAAAAAAAAAAhEh/9oACAEDAQE/AcVF/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8Bqv/EABkQAQACAwAAAAAAAAAAAAAAAAAhMQECQf/aAAgBAQAGPwLCHWsKU//EABkQAQEBAQEBAAAAAAAAAAAAAAERADEhYf/aAAgBAQABPyECKt7otwOjnOt6fj+atozbjf/aAAwDAQACAAMAAAAQM+//xAAYEQEAAwEAAAAAAAAAAAAAAAABABFhkf/aAAgBAwEBPxCk2kwez//EABYRAQEBAAAAAAAAAAAAAAAAAAERAP/aAAgBAgEBPxCpMM3/xAAaEAEBAQEBAQEAAAAAAAAAAAABEQAhMWGB/9oACAEBAAE/EA45IhvT5rwLBUfmEPB631z9WrRyXme0L1pgKD+b/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "A woman has her picture taken posing as the \"I\" in Hico",
            "title": "A woman has her picture taken posing as the \"I\" in Hico",
            "src": "/static/6dc81a5db5d0d1a13cdb87b395dc64dd/2e753/prairies-lakes-hico.jpg",
            "srcSet": ["/static/6dc81a5db5d0d1a13cdb87b395dc64dd/69549/prairies-lakes-hico.jpg 288w", "/static/6dc81a5db5d0d1a13cdb87b395dc64dd/473e3/prairies-lakes-hico.jpg 576w", "/static/6dc81a5db5d0d1a13cdb87b395dc64dd/2e753/prairies-lakes-hico.jpg 1152w", "/static/6dc81a5db5d0d1a13cdb87b395dc64dd/74f4b/prairies-lakes-hico.jpg 1728w", "/static/6dc81a5db5d0d1a13cdb87b395dc64dd/12e8d/prairies-lakes-hico.jpg 1800w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Mural depicting piano player and composer Scott Joplin in Texarkana. Photo by Tom McCarthy Jr.</Caption>
        <h2><strong parentName="h2">{`Walk It Out`}</strong></h2>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colSm={12} colMd={6} colLg={8} mdxType="Column">
        <h3>{`Pedestrian-friendly Hico has plenty of diversions to explore on foot`}</h3>
        <p><strong parentName="p">{`By June Naylor`}</strong></p>
        <p>{`For a town of around 1,500, Hico packs a wallop, drawing in city dwellers who enjoy small town charm paired with urban amenities. Sitting at the tip-top of the Hill Country, where US 281 crosses State Highway 6, Hico (HYE-coe) first earned its stop-worthy reputation from the towering meringue pies at the Koffee Kup Family Restaurant. These days, there’s far more than dessert to keep travelers amused for a full weekend (though Wiseman House Chocolates is still around to satisfy a sweet tooth). Everything’s in walking distance, from the limestone-studded Bosque River on the south end of downtown to the statue of Billy the Kid—the outlaw said to have lived out his life here in anonymity—at the north end of downtown. The only time a car is needed is to head 20 miles south to Hamilton to check out art, music, and eats in the seat of Hamilton County.`}</p>
      </Column>
      <Column colSm={3} colMd={2} colLg={3} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "528px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "186.80555555555557%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,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')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "A map showing distances from Hico",
            "title": "A map showing distances from Hico",
            "src": "/static/a076bdf813ae141cd085fa4fd0637416/3d774/prairies-lakes-map.png",
            "srcSet": ["/static/a076bdf813ae141cd085fa4fd0637416/7fc1e/prairies-lakes-map.png 288w", "/static/a076bdf813ae141cd085fa4fd0637416/3d774/prairies-lakes-map.png 528w"],
            "sizes": "(max-width: 528px) 100vw, 528px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colSm={12} colMd={5} colLg={8} mdxType="Column">
        <h3>{`Stay`}</h3>
        <h4>{`Midland Hotel & Chop House`}</h4>
        <p>{`The handsome brick building anchoring one downtown corner is an 1896 landmark offering 14 rooms (starting at $149 a night) with historical beauty and modern comforts, as well as an exceptional restaurant (see sidebar below).`}</p>
        <h3>{`Shop`}</h3>
        <h4>{`Hico Mercantile`}</h4>
        <p>{`The grand 1895 opera house is now home to an assemblage of fresh boutiques where one can purchase a range of items, including a Dolly Parton prayer candle, wooden candlesticks, and framed vintage botanical prints.`}</p>
        <h4>{`Hill Country Dwellings`}</h4>
        <p>{`A side hustle of sisters and designers Jane and Cindy Schumacher, this shop shines with earthy sophistication in its selection of textiles, handmade wooden biscuit cutters, locally crafted pottery, and art.`}</p>
        <h3>{`See`}</h3>
        <h4>{`City Park`}</h4>
        <p>{`Wander south along Elm Street, which ends at this shady, welcoming retreat on the Bosque River. Enormous pecan trees provide shelter from the sun, and plentiful tables near the clear water supply a bucolic backdrop for picnicking.`}</p>
        <h4>{`Ramsey Collection`}</h4>
        <p>{`Book an appointment to see a stunning private collection of American and European art from the 16th to early 20th centuries. The former bank building on the Hamilton County Courthouse square houses hundreds of works by the likes of Edgar Degas and Diego Rivera.`}</p>
        <h3>{`Eat`}</h3>
        <h4>{`The Grain Drafthouse & Eatery`}</h4>
        <p>{`Look for the old grain silos, relocated from a nearby farm, to find Hamilton’s new live music venue. Listen to headliners like Gary P. Nunn and local acts while eating fried cheese curds and sipping a ranch water.`}</p>
        <h4>{`2nd Street Bakeshop & Coffee Co.`}</h4>
        <p>{`A refurbished Victorian home makes morning coffee and afternoon tea special events. Few things are more comforting than settling into a corner here with a seasonal honey-lavender latte, a lemon-blueberry scone, and a good book.`}</p>
        <h4>{`Eis`}</h4>
        <p>{`The sandwich and ice cream shop offers a delicious smoked chicken salad sandwich along with a selection of locally sourced sodas, wines, and beer. Pair with locally made cheeses and smokehouse meats to complete a riverside picnic.`}</p>
        <h3>{`All a Board`}</h3>
        <p>{`It’s more than chef Eric Hunter’s menu that inspires return visits to the Chop House, found within the Midland Hotel. It’s the inspired craftsmanship he employs with every item. He makes the cavatelli pasta from semolina fresh each morning. He prepares smoked brisket and queso as well as molasses-cured salmon. The charcuterie presentation involves meats he cured, grainy mustard he made from scratch, vegetables and fruits he pickled, and even a wooden board he milled, cut, stained, and finished. You taste the passion in every bite.`}</p>
        <h3>{`RV Info`}</h3>
        <p>{`Bosque River RV Park has 21 spaces to pull your RV into. Hook up to the complimentary Wi-Fi or enjoy the park’s volleyball court and hike-and-bike trail. 500 Elm St. 254-796-4620, ext. 2; `}<a parentName="p" {...{
            "href": "http://hico-tx.com/visitors/rv-park"
          }}>{`hico-tx.com/visitors/rv-park`}</a></p>
      </Column>
      <Column colSm={12} colMd={3} colLg={3} mdxType="Column">
        <StatePark mdxType="StatePark">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "150.34722222222223%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMBAgUE/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQIA/9oADAMBAAIQAxAAAAGnbnOgoJKy9JECssB//8QAHRAAAwEAAQUAAAAAAAAAAAAAAQIDERIAEyEyM//aAAgBAQABBQKfwXotxaTZIE92/ikgSNO09kUzXTrLyP8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/Aaitj//EAB0QAAICAQUAAAAAAAAAAAAAAAABEBFBEiExYYH/2gAIAQEABj8CvuhjPTTibjG5yW2z/8QAGxAAAgMBAQEAAAAAAAAAAAAAAAERITFBYXH/2gAIAQEAAT8hhPrAzOm7hik/eirTCrcC7TxGpaVs0GpiBO5N5Lo1fQiwT//aAAwDAQACAAMAAAAQ0Cly/8QAFxEBAQEBAAAAAAAAAAAAAAAAEQABMf/aAAgBAwEBPxAWLeTl/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARIf/aAAgBAgEBPxAKWMLs5Ff/xAAdEAEAAgMBAQEBAAAAAAAAAAABESEAMUFRYXHB/9oACAEBAAE/EBDTc/Uxz+5C6pkG91HMjiG3qwwDtX4oQ7wK36JmOziQFmg+YXAhgLJqMIUvsrWd1MbBM7wJBKh5eA2JeryP0jjn/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "A group of people walk down a trail in a wooded area",
              "title": "A group of people walk down a trail in a wooded area",
              "src": "/static/ae74cb637b95179f1eef39f9ddf6d1ea/2e753/piney-woods-mission-tejas.jpg",
              "srcSet": ["/static/ae74cb637b95179f1eef39f9ddf6d1ea/69549/piney-woods-mission-tejas.jpg 288w", "/static/ae74cb637b95179f1eef39f9ddf6d1ea/473e3/piney-woods-mission-tejas.jpg 576w", "/static/ae74cb637b95179f1eef39f9ddf6d1ea/2e753/piney-woods-mission-tejas.jpg 1152w", "/static/ae74cb637b95179f1eef39f9ddf6d1ea/040c5/piney-woods-mission-tejas.jpg 1200w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
          <Caption mdxType="Caption">Lake Ray Roberts State Park. Photo by Chase Fountain, TPWD</Caption>
          <h5>{`Prairies and Lakes`}</h5>
          <h3>{`Celebrate 100 Years of Texas State Parks`}</h3>
          <p>{`Join in the celebration! The Texas State Parks system is turning 100 years old in 2023. Learn more and discover all the ways you can help celebrate at `}<a parentName="p" {...{
              "href": "https://texasstateparks.org/100years"
            }}>{`texasstateparks.org/100years`}</a>{`.`}</p>
          <h4>{`Fort Boggy State Park`}</h4>
          <p>{`Halfway between Dallas and Houston on I-45, quiet Fort Boggy offers a peaceful getaway. Hike or bike on 3 miles of trails or swim, paddle, or fish in 15-acre Sullivan Lake. (Pro tip: You don’t need a fishing license in a state park.) Maximize your zen time by upgrading to a cabin (some of the newest in the Texas State Parks system) with multiple beds, climate control, and a screened-in porch.`}</p>
          <h4>{`More Prairies and Lakes State Parks`}</h4>
          <p><strong parentName="p">{`Bastrop State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Bonham State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Buescher State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Cedar Hill State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Cleburne State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Cooper Lake State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Dinosaur Valley State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Eisenhower State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Fairfield Lake State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Fort Parker State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lake Mineral Wells `}</strong></p>
          <br />
          <p><strong parentName="p">{`State Park & Trailway`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lake Somerville State Park & Trailway`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lake Tawakoni State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lake Whitney State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Lockhart State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Meridian State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Mother Neff State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Palmetto State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Purtis Creek State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Ray Roberts Lake State Park`}</strong></p>
          <br />
          <p><strong parentName="p">{`Stephen F. Austin State Park`}</strong></p>
          <br />
        </StatePark>
      </Column>
    </Row>
    <AdGroup id={['ad27', 'ad31', 'ad03', 'ad10', 'ad23', 'ad28', 'ad06', 'ad09']} mdxType="AdGroup" />
    <Row mdxType="Row">
      <Column colSm={12} colMd={4} colLg={8} mdxType="Column">
        <RegionListing title="Prairies and Lakes" color="teal" region="PRAIRIES AND LAKES" ads={['ad68', 'ad51', 'ad85', 'ad95', 'ad82', 'ad103', 'ad80']} mdxType="RegionListing" />
      </Column>
      <Column colSm={12} colMd={4} colLg={4} mdxType="Column">
      </Column>
    </Row>
    {
      /*
      <FeatureCard
       title="Search all cities and listings in the Piney Woods"
       actionIcon="arrowRight"
       href="/things-to-do-in-texas?region=piney-woods"
       color="dark">
      ![Trees reflect against blue sky and clear water in a bayou](/images/piney-woods-view-all-listings.jpg)
      </FeatureCard>
      <Caption>Big Thicket National Preserve, 10 Mile Bayou. Photo by Will van Overbeek.</Caption>
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      